import React from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { Select } from '../../../../components/Form'
import { getListOptions, getDataListIsFetching } from '../../selectors/index'
import getFormValidations from './formValidations'
import {colourStyles} from '../Filter/SelectStyles'
import {translateName} from '../../../../utils/i18n'
import './Tags.css'
import readOnly from "./ReadOnly";

// binding for redux-form
const DropDown = ({
    input: { value, onChange, onBlur },
    meta: { touched, error },
    required,
    path,
    display,
    placeholder,
    selectOptions,
    originalOptionsById,
    optionsById,
    disabled,
    editable,
    clearable,
    readOnly,
    t,
    language,
    style = {},
    selectedColor,
    warnIfNotFound,
    isLoading
}) => {
    const translatedError = t(error)
    const finalValue = value && value.map(o => {
        return optionsById[o.id] || {value: o.id, label: o[display], notFound: true, warn: warnIfNotFound, optionData: o}
    })

    const groupSelectedColor = selectedColor ? {color: selectedColor} : {}

    return readOnly
        ? <div className='tagsForDocuments' style={{...style, ...groupSelectedColor}}>
            {finalValue && finalValue.map(element => <span style={groupSelectedColor} className="Article-tag">{translateName(element.label, language)}</span>)}
        </div>
        : <Select
            path={path}
            required={required}
            options={selectOptions}
            noOptionsMessage={() => t('noOptions')}
            className="Form-TagsField"
            isMulti={true}
            styles={colourStyles}
            style={style}
            multi={true}
            disableWidthClass={true}
            isLoading={isLoading}
            onChange={options => {
                const selectAll = options && options.some(option => option.value === 'selectAll')

                if(selectAll) {
                    return onChange(
                        selectOptions.slice(1).map(o => originalOptionsById[o.value])
                    )
                }
                onChange(
                    options && options.map(o => (o.notFound ?
                            o.optionData
                            : o.id ?
                                o
                                : originalOptionsById[o.value]
                    ))//.filter(d => d)
                )
            }}
            value={finalValue}
            touched={touched}
            error={translatedError}
            onBlur={() => onBlur()}
            isDisabled={disabled || !editable}
            isClearable={clearable}
            isToto={clearable}
            placeholder={t(placeholder || 'select')}
            t={t}
        />
}

class Tags extends React.Component {
    constructor(props){
        super(props)
        this.validations = getFormValidations(props.field, props.t)
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return JSON.stringify(this.props) !== JSON.stringify(nextProps)
    }

    render() {
        const { field, options, t, objectMode, language, groupModel, selectedColor, isLoading } = this.props
        const originalOptionsById = options.reduce((acc, option) => {
            return {
                ...acc,
                [option.id]: option
            }
        }, {})
        const optionsById = options.reduce((acc, option) => {
            return {
                ...acc,
                [option.id]: {
                    value: option.id,
                    label: field.translateName
                        ? translateName(option[field.display], language)
                        : field.translate
                            ? t(option[field.display])
                            : option[field.display],
                }
            }},{})

        const selectOptions = [{value: 'selectAll', label: t('selectAll')}, ...options.map(option => optionsById[option.id])]

        return (
            <Field
                name={field.path}
                required={field.required}
                path={field.tKey || field.path}
                display={field.display}
                readOnly={field.readOnly}
                component={DropDown}
                selectOptions={selectOptions}
                placeholder={field.placeholder}
                originalOptionsById={originalOptionsById}
                optionsById={optionsById}
                disabled={field.disabled || !field.writable}
                editable={!field.editable ? objectMode === 'newObject' : field.editable  }
                validate={this.validations}
                clearable={field.clearable}
                style={field.style}
                warnIfNotFound={field.warnIfNotFound !== false}
                isLoading={isLoading}
                t={t}
                selectedColor={selectedColor}
                language={language}
            />
        )
    }
}

const mapStateToProps = (state, { field, t }) => ({
    options: getListOptions(state, field.id, field.sortList, field.translate, t),
    isLoading: field.dataList ? getDataListIsFetching(state, field.dataList) : false
})

export default connect(mapStateToProps)(Tags)
